import { render, staticRenderFns } from "./UserCreateEditPage.vue?vue&type=template&id=526588fc&"
import script from "./UserCreateEditPage.vue?vue&type=script&lang=js&"
export * from "./UserCreateEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports